import React, { useState } from 'react';
import { T } from '../utils/theme';
import * as api from '../utils/api';
import { Btn, Modal, IcTrash } from './UI';

// One confirmation for deleting a product, wherever the button is (the product list, an item open in
// quoting), so both say the same thing about the versions that go with it and the ones that do not.
export default function DeleteProductModal({ lang, products, productId, onClose, onDeleted, Lk }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const dp = products.find(p => p.id === productId);

  const close = () => { setErr(null); onClose(); };
  const doDelete = async () => {
    setBusy(true);
    setErr(null);
    try {
      await api.deleteProduct(dp.id);
      await onDeleted(dp.id);
    } catch (e) {
      setErr(String(e.message || ''));
    } finally { setBusy(false); }
  };

  return (
    <Modal open={productId != null} onClose={close}>
      {(() => {
        if (!dp) return null;
        const suggestedAgainst = products.filter(x => x.variant_parent_id === dp.id);
        const waitingOnIt = suggestedAgainst.filter(x => x.variant_state === 'provisional').length;
        const acceptedFromIt = suggestedAgainst.length - waitingOnIt;
        return (
          <div style={{ textAlign: 'center' }}>
            <div style={{ width: 48, height: 48, borderRadius: 24, background: T.dangerBg, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', border: `1px solid ${T.danger}30`, color: T.danger }}>{IcTrash}</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: T.text, marginBottom: 8 }}>{Lk('deleteTitle')}</div>
            <div style={{ fontSize: 14, color: T.muted, marginBottom: 6 }}>{Lk('deleteMsg')} <span style={{ fontWeight: 700, color: T.text }}>"{dp.name}"</span>?</div>
            <div style={{ fontSize: 12, color: T.dim, marginBottom: waitingOnIt > 0 || acceptedFromIt > 0 ? 12 : 24 }}>{Lk('deleteWarn')}</div>
            {/* Deleting an item a supplier has suggested versions against needs saying out loud:
                what we accepted survives on its own, what is still waiting cannot outlive it. */}
            {waitingOnIt > 0 && (
              <div style={{ fontSize: 12, color: T.warn, background: T.warnBg, border: `1px solid ${T.warn}55`, borderRadius: 8, padding: '8px 12px', marginBottom: 8, textAlign: 'left' }}>
                {lang === 'zh'
                  ? `${waitingOnIt} 个待审核的版本建议将一并撤回——它们只能在此产品上审核。`
                  : `${waitingOnIt} suggested version${waitingOnIt > 1 ? 's' : ''} still waiting for review will be withdrawn with it — ${waitingOnIt > 1 ? 'they' : 'it'} can only be reviewed here.`}
              </div>
            )}
            {acceptedFromIt > 0 && (
              <div style={{ fontSize: 12, color: T.muted, background: T.surfaceAlt, border: `1px solid ${T.border}`, borderRadius: 8, padding: '8px 12px', marginBottom: 16, textAlign: 'left' }}>
                {lang === 'zh'
                  ? `${acceptedFromIt} 个已接受的版本是独立产品，不受影响。`
                  : `${acceptedFromIt} accepted version${acceptedFromIt > 1 ? 's are' : ' is'} ${acceptedFromIt > 1 ? '' : 'a '}product${acceptedFromIt > 1 ? 's' : ''} in ${acceptedFromIt > 1 ? 'their' : 'its'} own right and stay${acceptedFromIt > 1 ? '' : 's'} untouched.`}
              </div>
            )}
            {err && (
              <div style={{ fontSize: 12, color: T.danger, background: T.dangerBg, border: `1px solid ${T.danger}55`, borderRadius: 8, padding: '8px 12px', marginBottom: 12, textAlign: 'left' }}>{err}</div>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <Btn variant="secondary" onClick={close} style={{ flex: 1 }}>{Lk('cancel')}</Btn>
              <Btn variant="danger" disabled={busy} onClick={doDelete} style={{ flex: 1 }}>{Lk('confirm')}</Btn>
            </div>
          </div>
        );
      })()}
    </Modal>
  );
}
